import Transport from '../../common/services/api/Transport';

const transport = new Transport();

export const getUserNotifications = async () => {
    try {
        const result = await transport.get({ path: `notifications` });
        return result.data.statusCode === 200 ? result.data.data.notifications : [];
    } catch (error) {
        return [];
    }
};

export const getUserNotificationsCount = async () => {
    try {
        const result = await transport.get({ path: `notifications/count` });
        return result.data.statusCode === 200 ? result.data.data.notificationsCount : 0;
    } catch (error) {
        return 0;
    }
};

export const createNotification = async notificationData => {
    try {
        const result = await transport.post({
            path: `notifications`,
            data: notificationData,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return {};
    }
};

export const markNotificationAsSeen = async notificationId => {
    try {
        const result = await transport.put({
            path: `notifications/${notificationId}/seen`,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return {};
    }
};

export const deleteNotification = async notificationId => {
    try {
        const result = await transport.delete({ path: `notifications/${notificationId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return {};
    }
};
